import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-technical-issues-table',
  templateUrl: './technical-issues-table.component.html',
  styleUrls: ['./technical-issues-table.component.css']
})
export class TechnicalIssuesTableComponent implements OnInit {
  @Output() auditSelected = new EventEmitter<any>();

  audits: any[] = [];
  priority = '';
  limit = 20;
  loading = true;
  url = 'seoTechnicalAudits'

  constructor(private dataService: DataService) { }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.loading = true;
    let url = `${this.url}/issues?limit=${this.limit}`;
    if (this.priority) url += `&priority=${this.priority}`;

    this.dataService.getData(url).subscribe(res => {
      if (res.rst) {
        this.audits = res.data;
      }
      this.loading = false;
    });
  }

  setPriority(p: string) {
    this.priority = p;
    this.getData();
  }

  selectAudit(audit: any) {
    this.auditSelected.emit(audit);
  }

  getPriorityBadgeClass(p: string) {
    switch (p) {
      case 'P0': return 'badge-danger';
      case 'P1': return 'badge-warning';
      case 'P2': return 'badge-info';
      default: return 'badge-secondary';
    }
  }

  getScoreColor(score: number) {
    if (score >= 80) return 'text-success';
    if (score >= 50) return 'text-warning';
    return 'text-danger';
  }
}
